var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransferbonus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8.16737V17.8335C0 19.3067 1.19333 20.5 2.66667 20.5H17.3333C18.8067 20.5 20 19.3067 20 17.8335V8.16737C20 6.91411 19.0133 5.8875 17.7633 5.83417C18.09 4.93089 18.0767 3.93761 17.7233 3.041C17.1 1.47442 15.57 0.461145 13.8833 0.501143C12.3933 0.537807 10.9833 1.19444 10 2.31771C9.01667 1.19777 7.60667 0.537807 6.11667 0.501143C4.43 0.461145 2.89667 1.47442 2.27667 3.04433C1.92333 3.93761 1.91 4.93089 2.23667 5.83417C0.986667 5.8875 0 6.91744 0 8.16737ZM14 3.16766C14.7367 3.16766 15.3333 3.76429 15.3333 4.50091C15.3333 5.23754 14.7367 5.83417 14 5.83417H11.3333C11.3333 4.36092 12.5267 3.16766 14 3.16766ZM11.3333 8.50068H17.3333V17.8335H11.3333V8.50068ZM6 3.16766C7.47333 3.16766 8.66667 4.36092 8.66667 5.83417H6C5.26333 5.83417 4.66667 5.23754 4.66667 4.50091C4.66667 3.76429 5.26333 3.16766 6 3.16766ZM2.66667 8.50068H8.66667V17.8335H2.66667V8.50068Z",
    fill: "#FFBB00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransferbonus);
export default __webpack_public_path__ + "static/media/transferbonus.78f04a4903956d689ba473cb6e12edc0.svg";
export { ForwardRef as ReactComponent };